import React,{useState} from 'react';
import "./City.css";
// import {Link} from "react-router-dom";

function City({setSearch}) {
    const [city, setCity] = useState("")
    return (
        <>
         <img className="WelcomeWeatherLogo" src="icons/perfect-day.svg" alt="" />
                <h1>Check The Weather ⛅ Of Your Favorite City 🌆</h1>
        <div className="City" >
      
            <input
             onChange={(e) =>setCity(e.target.value)}
             placeholder="Example: New York "
            />
     
             <button onClick={() => setSearch(city)}>Search</button>
     
           
        </div>
        </>
    );
}

export default City;